<template>
  <div class="atPoint" style="position: relative; width: 26px; height: 26px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 12 12">
      <circle r="5" transform="matrix(1 0 0 1 6 6)" fill="#ffffff" fill-rule="evenodd" stroke="#37474f"
        stroke-width="1.5" />
    </svg>
    <!-- <i :class="'fa-user-nurse'" class="fas iconAtCenter" style="font-size: 14px;"></i> -->
    <i :class="iconSpecial" class="fas iconAtCenter" style="font-size: 14px;"></i>
    <!-- <i :class="'fa-map-pin'" class="fas iconAtCenter" style="font-size: 14px;"></i> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    deviceId: {
      type: Number,
      required: true
    },
    iconActive: {
      type: Boolean,
    },
    pathColor: {
      type: String,
      default: 'currentColor'
    },
  },
  computed: {
    ...mapGetters([
      'positions'
    ]),
    iconSpecial() {
      // return this.deviceId === 62 ? 'fa-flag-checkered' : 'fa-map-pin'
      // return this.deviceId === 62 ? 'fa-user-nurse' : 'fa-stopwatch'
      return this.deviceId === 62 ? 'fa-map-marker' : 'fa-map-pin'
    },
  }
}
</script>

<style lang="scss" scoped>
.atPoint {
  translate: -7px -7px;
}

.iconAtCenter {
  color: #37474F;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
